import { AccessControlProvider } from '@refinedev/core';

export const accessControlProvider: AccessControlProvider = {
  // can: async ({ resource, action }) => {
  can: async (_params) => {
    return { can: true, reason: undefined };
  },
};
